import { useBridge } from '@onl-web/shared/bridge'

import { ErrorExitDialog } from '@/components/ErrorExitDialog'
import { LoadingOverlay } from '@/components/ui/LoadingOverlay'
import { CompleteStep } from '@/pages/SealedVinylPage/steps/CompleteStep'

import { CenteredContainer, StateDescription, StateTitle, SuccessWrap } from './styles'

export function LoadingView() {
  return <LoadingOverlay />
}

export function SuccessView() {
  const { callHandler } = useBridge()
  // closeWebView 는 v2 핸들러 규약에서 미지원 → webview 종료는 onPrevious 로 통일.
  return (
    <SuccessWrap>
      <CompleteStep onConfirm={() => void callHandler('onPrevious', { pages: 1 })} />
    </SuccessWrap>
  )
}

export function FailureView() {
  return (
    <CenteredContainer role='alert' aria-live='polite'>
      <StateTitle>결제가 취소됐어요</StateTitle>
      <StateDescription>다시 시도하시려면 처음부터 진행해주세요</StateDescription>
    </CenteredContainer>
  )
}

export function UnknownView() {
  // 결과 확인 불가(토큰 timeout·process/콜백 실패·인식 불가) — 안내 모달 후 앱 이탈
  return <ErrorExitDialog />
}
